import styled from '@emotion/styled';
import { Button, Form, Input, Tag } from 'antd';
import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { NeedToUpdateStore } from 'services/api/admin';
import { useStoreNameConfig, isStoreAliasFirst } from 'hooks/business/store/useStoreName';

const AccountItem = styled.div`
  background-color: var(--fett-erp-card-bg);
  position: relative;
  padding: 30px 15px 22px 15px;
  margin-bottom: 16px;

  .corner-mark {
    position: absolute;
    left: 0;
    top: 0;
    color: var(--fett-scenario-accent-text);
  }

  .store-alias {
    color: var(--fett-text-tertiary);
    margin-left: 6px;
    font-size: 12px;
  }
  form {
    margin-top: 12px;
  }
  .ant-pagination {
    text-align: right;
  }
  button {
    background-color: #336fff;
    color: #ffffff;
  }
`;
export type AccountFormValue = Omit<NeedToUpdateStore, 'storeName' | 'storeNameAlias'>;

interface Props {
  item: NeedToUpdateStore;
  onChange: (values: AccountFormValue) => void;
  index: number;
  onSubmit: (values: AccountFormValue) => void;
  loading: boolean;
  passwordValidator: (value: string) => string | undefined;
}

const UpdateAccountForm = (props: Props) => {
  const { item, index, onSubmit, onChange, loading, passwordValidator } = props;
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const { t } = useTranslate();
  const { config } = useStoreNameConfig();
  const name =
    isStoreAliasFirst(config, 'SHOPEE', item.region) && item.storeAlias
      ? item.storeAlias
      : item.storeName;
  const alias =
    isStoreAliasFirst(config, 'SHOPEE', item.region) && item.storeAlias
      ? item.storeName
      : item.storeAlias;
  const { storeId } = item;
  return (
    <AccountItem key={item.storeId}>
      <Tag className="corner-mark" color="#D7E1FA">
        {t('ViewShops.店铺')}
        {index + 1}
      </Tag>
      <div>
        <span className="store-name">{name}</span>
        {alias && <span className="store-alias">[{alias}]</span>}
      </div>
      <Form
        form={form}
        layout="inline"
        initialValues={{ ...item, password: '' }}
        onValuesChange={(changed, all) => {
          setDisabled(!all.account || !all.password);
          onChange({ ...all, storeId });
        }}
        onFinish={(values) => {
          onSubmit({ ...values, storeId });
        }}
      >
        <Form.Item name="account" label={t('ViewShops.帐号')} required>
          <Input autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="password"
          label={t('ViewShops.密码')}
          required
          rules={[
            {
              validator(_, value) {
                const errText = passwordValidator(value);
                if (errText) {
                  return Promise.reject(new Error(errText));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input autoComplete="new-password" />
        </Form.Item>
        <Button disabled={disabled || loading} htmlType="submit">
          {t('ViewShops.更新')}
        </Button>
      </Form>
    </AccountItem>
  );
};

export default UpdateAccountForm;
